import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiltersForm } from '../components/FiltersForm';
import { SvgBarChart } from '../components/SvgBarChart';
import { Table } from '../components/Table';
import { DownloadMenu } from '../components/DownloadMenu';
import { Section } from '../components/Section';
import { funnelSchema } from '../validation';
import { useKpiFunnel, useQueryParams } from '../hooks/useKpi';
import type { FunnelParams } from '../types';

const defaults: FunnelParams = { collection: '', stages: [] };

export default function Funnel() {
  const [search] = useSearchParams();
  const merged = useQueryParams(defaults, search) as any;
  const [params, setParams] = useState<FunnelParams | undefined>(merged.collection ? merged : undefined);
  const query = useKpiFunnel(params);

  return (
    <Section title="Embudo" description="Revisa conversiones entre etapas">
      <FiltersForm defaultValues={merged} schema={funnelSchema} fields={[{ name: 'collection', label: 'Colección' }, { name: 'stages', label: 'Etapas (coma separadas)', placeholder: 'lead,checkout,pago' }]} onSubmit={(values) => setParams({ ...values, stages: Array.isArray(values.stages) ? values.stages : String(values.stages ?? '').split(',').filter(Boolean) })} />
      {query.isLoading && <p>Cargando...</p>}
      {query.error && <p className="text-red-600">Error al cargar</p>}
      {query.data && <div className="space-y-4"><SvgBarChart data={query.data.map((d) => ({ label: d.stage, value: d.value }))} /><DownloadMenu filename="funnel" rows={query.data as any} /><Table rows={query.data as any} /></div>}
    </Section>
  );
}
